var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { updateByCollectionResponse } from "framework/state/collection";
import { load, loadLast, update } from "framework/state/loader";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { setEntityField } from "framework/state/setfield";
import { NoEntityError, updateByEntityResponse } from "framework/validation/validatableentity";
import { createHook, createStore } from "react-sweet-state";
import { apiGetNationalTeam, apiGetNationalTeams, apiHideNationalTeam, apiPublishNationalTeam } from "./endpoint";
import { NationalTeamStatus } from "./entity";
import { AgeType, CompetitorType, DisciplineType, SeriesType } from "public_app/events/entity";
// Filter
export var nrtCompetitorTypeValues = [
    'CoupleAmateur',
    'CoupleProfessional',
    'DuoTPV',
    'SoloTPV',
];
export var competitorTypeToString = function (competitorType) {
    if (competitorType === 'CoupleAmateur') {
        return "Páry (Výkonnostní sport)";
    }
    if (competitorType === 'CoupleProfessional') {
        return "Páry (Profesionálové)";
    }
    if (competitorType === 'DuoTPV') {
        return "Dua (TPV)";
    }
    if (competitorType === 'SoloTPV') {
        return "Jednotlivci (TPV)";
    }
    return '';
};
var nrtAgeValuesAmateur = [
    AgeType.Junior_I,
    AgeType.Junior_II,
    AgeType.Youth,
    AgeType.Under_21,
    AgeType.Adult,
    AgeType.Senior_I,
    AgeType.Senior_II,
    AgeType.Senior_III,
    AgeType.Senior_IV,
];
var nrtAgeValuesProfessional = [
    AgeType.Adult,
];
var nrtAgeValuesTPV = [
    AgeType.Junior_I,
    AgeType.Junior_II,
    AgeType.Youth,
    AgeType.Under_21,
    AgeType.Adult,
];
export var getNRTAgeValues = function (competitorType) {
    if (competitorType === 'CoupleAmateur') {
        return nrtAgeValuesAmateur;
    }
    if (competitorType === 'CoupleProfessional') {
        return nrtAgeValuesProfessional;
    }
    if (competitorType === 'DuoTPV') {
        return nrtAgeValuesTPV;
    }
    if (competitorType === 'SoloTPV') {
        return nrtAgeValuesTPV;
    }
    return nrtAgeValuesAmateur;
};
var nrtDisciplineValues = [
    DisciplineType.Standard,
    DisciplineType.Latin,
    DisciplineType.TenDance,
];
var nrtDisciplineValuesTPV = [
    DisciplineType.Standard,
    DisciplineType.Latin,
];
export var getNRTDisciplineValues = function (competitorType) {
    if (competitorType === 'CoupleAmateur') {
        return nrtDisciplineValues;
    }
    if (competitorType === 'CoupleProfessional') {
        return nrtDisciplineValues;
    }
    if (competitorType === 'DuoTPV') {
        return nrtDisciplineValuesTPV;
    }
    if (competitorType === 'SoloTPV') {
        return nrtDisciplineValuesTPV;
    }
    return nrtDisciplineValues;
};
var FilterStateDefaults = {
    entity: {
        competitorType: null,
        age: null,
        discipline: null,
        chosenNationalTeamId: null,
    },
    errors: __assign({}, NoEntityError),
};
var setFilterEntityField = function (field, value, validator, storeInvalidValue) { return function (store) {
    store.setState(function (draft) {
        setEntityField(draft.filter, field, value, validator, storeInvalidValue);
        if (field === 'competitorType') {
            // if (value === 'CoupleAmateur') {
            //     if (draft.filter.entity.age !== null && !nrtAgeValuesAmateur.map(v => v.toString()).includes(draft.filter.entity.age)) {
            //         draft.filter.entity.age = null;
            //     }
            // }
            if (value === 'CoupleProfessional') {
                if (draft.filter.entity.age !== null && draft.filter.entity.age !== 'null' && !nrtAgeValuesProfessional.map(function (v) { return v.toString(); }).includes(draft.filter.entity.age)) {
                    draft.filter.entity.age = 'null';
                }
            }
            // if (value === 'CoupleAmateur' || value === 'CoupleProfessional') {
            //     if (draft.filter.entity.discipline !== null && !nrtDisciplineValues.map(v => v.toString()).includes(draft.filter.entity.discipline)) {
            //         draft.filter.entity.discipline = null;
            //     }
            // }
            if (value === 'DuoTPV' || value === 'SoloTPV') {
                if (draft.filter.entity.age !== null && draft.filter.entity.age !== 'null' && !nrtAgeValuesTPV.map(function (v) { return v.toString(); }).includes(draft.filter.entity.age)) {
                    draft.filter.entity.age = 'null';
                }
                if (draft.filter.entity.discipline !== null && draft.filter.entity.discipline !== 'null' && !nrtDisciplineValuesTPV.map(function (v) { return v.toString(); }).includes(draft.filter.entity.discipline)) {
                    draft.filter.entity.discipline = 'null';
                }
            }
        }
    });
    if (field !== 'chosenNationalTeamId') {
        filterNationalTeams(store);
    }
}; };
var NationalTeamStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError) });
var loadNationalTeam = function (nrtId) { return function (store) {
    var loader = function () { return apiGetNationalTeam(nrtId); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByEntityResponse(draft.national_team, response);
        });
    };
    load(store, loader, stateProducer, function (s) { return s.national_team; });
}; };
var filterNationalTeams = function (store) {
    var state = store.getState();
    var seriesFilter = null;
    var competitorTypeFilter = null;
    if (state.filter.entity.competitorType === 'CoupleAmateur') {
        seriesFilter = SeriesType.DanceSport;
        competitorTypeFilter = CompetitorType.Couple;
    }
    else if (state.filter.entity.competitorType === 'CoupleProfessional') {
        seriesFilter = SeriesType.Professional;
        competitorTypeFilter = CompetitorType.Couple;
    }
    else if (state.filter.entity.competitorType === 'DuoTPV') {
        seriesFilter = SeriesType.DanceForAll;
        competitorTypeFilter = CompetitorType.Duo;
    }
    else if (state.filter.entity.competitorType === 'SoloTPV') {
        seriesFilter = SeriesType.DanceForAll;
        competitorTypeFilter = CompetitorType.SoloDancer;
    }
    store.setState(function (draft) {
        if (draft.filter.entity.age !== null && draft.filter.entity.age !== 'null'
            && draft.filter.entity.discipline !== null && draft.filter.entity.discipline !== 'null'
            && seriesFilter !== null
            && competitorTypeFilter !== null) {
            draft.filtered_national_teams = draft.national_teams.collection.filter(function (r) {
                if (r.discipline.toString() === draft.filter.entity.discipline
                    && r.age.toString() === draft.filter.entity.age
                    && r.series === seriesFilter
                    && r.competitorType === competitorTypeFilter) {
                    return true;
                }
                return false;
            });
            if (!draft.filtered_national_teams.map(function (r) { return r.id; }).includes(parseInt(draft.filter.entity.chosenNationalTeamId))) {
                draft.filter.entity.chosenNationalTeamId = null;
            }
        }
        else {
            draft.filtered_national_teams = [];
            draft.filter.entity.chosenNationalTeamId = null;
        }
    });
    fillNewestNationalTeamIfPossible(store);
};
var fillNewestNationalTeamIfPossible = function (store) {
    store.setState(function (draft) {
        if (draft.filtered_national_teams.length > 0) {
            draft.filter.entity.chosenNationalTeamId = draft.filtered_national_teams[0].id.toString();
        }
    });
};
var updateNationalTeamStatus = function (nationalTeamId, val) { return function (store) {
    var updater = function () { return val === NationalTeamStatus.Private
        ? apiHideNationalTeam(nationalTeamId)
        : apiPublishNationalTeam(nationalTeamId); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByEntityResponse(draft.national_team, response);
        });
    };
    update(store, updater, stateProducer, function (s) { return s.national_team; });
}; };
var NationalTeamsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var loadNationalTeams = function () { return function (store) {
    var loader = function () { return apiGetNationalTeams(); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft.national_teams, response);
        });
        filterNationalTeams(store);
    };
    loadLast(store, loader, stateProducer, function (s) { return s.national_teams; });
}; };
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { filter: FilterStateDefaults, national_teams: NationalTeamsStateDefaults, national_team: NationalTeamStateDefaults, filtered_national_teams: [] });
var store = createStore({
    initialState: StateDefaults,
    actions: {
        setFilterEntityField: setFilterEntityField,
        loadNationalTeams: loadNationalTeams,
        loadNationalTeam: loadNationalTeam,
        updateNationalTeamStatus: updateNationalTeamStatus,
    },
    name: "NationalTeams"
});
var useState = createHook(store);
export { useState as useNationalRepresentationTeams, };
